<template>
  <div class="imd-sm-progrss-wrap">
    <spinner v-if="value" size="huge" style="position: absolute; margin: 30px 50%" />
    <!-- <v-progress-linear v-if="value" :indeterminate="value" class="imd-sm-progrss-bar"/> -->
  </div>
</template>

<style>
  div.imd-sm-progrss-wrap { width: 100%; position: relative; }
  div.imd-sm-progrss-wrap .imd-sm-progrss-bar { width: 100%; margin: 0; padding: 0; height: 3px; position: absolute; margin-top: -2px;}
</style>


<script>
import Spinner from 'vue-simple-spinner'
export default {
  props: ['value'],
  components: {
    Spinner
  },
}
</script>
